<template>
    <div class="robot-sorry-alert modal fade p-4" role="dialog">
        <div class="modal-dialog modal-dialog-centered justify-content-center" role="document">
            <div class="modal-content overflow-hidden w-auto">
                <div class="modal-body p-4 bg-white">
                    <div class="content-box flex items-center d-flex align-items-center">
                        <svg class="cry-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 650 649.99">
                            <path
                                d="m0,325C0,145.5,145.5,0,325,0h0c179.49,0,324.98,145.5,325,325h0c-.02,179.49-145.51,324.99-325,324.99h0C145.5,649.98,0,504.49,0,325h0ZM117.08,117.07c-53.23,53.26-86.12,126.67-86.12,207.92h0c0,81.25,32.89,154.66,86.12,207.92h0c53.26,53.24,126.68,86.12,207.92,86.12h0c81.24,0,154.65-32.88,207.92-86.12h0c53.23-53.26,86.12-126.67,86.12-207.92h0c0-81.26-32.89-154.66-86.12-207.92h0c-53.27-53.24-126.68-86.12-207.92-86.12h0c-81.25,0-154.67,32.88-207.92,86.12h0Zm-13.26,117.41c7.13-16.57,28.36-43.39,65.96-58.58,36.85-14.89,63.48-10.08,63.48-15.75,0-7.15-33.16-19.83-75.61,1.56-46.17,23.26-54.63,59.21-53.83,72.77Zm388.55-72.77c-42.45-21.39-75.62-8.71-75.62-1.56,0,5.67,26.64.86,63.48,15.75,37.6,15.19,58.83,42.01,65.96,58.58.8-13.57-7.65-49.51-53.83-72.77Zm-167.31,336.98c50.06,0,87.6,30.75,93.69,24.65,2.27-12.57-34.97-62.42-92.5-63.8-57.54,1.37-97.64,51.22-94.94,63.8,6.09,6.11,43.64-24.65,93.69-24.65h.07Zm-79.18-107.54c-3.43-6.82-7.03-13.15-10.18-18.38-2.49-4.14-4.69-7.6-6.33-10.09-1.58-2.42-2.6-3.9-2.81-4.2l-2.84-4.02-2.81,4.04c-.15.22-.68,1-1.54,2.29-1.63,2.46-4.35,6.67-7.54,12.02-3.13,5.24-6.7,11.58-10.12,18.42-7.08,14.28-13.58,30.56-13.63,44.29v.03s0,.1,0,.17c.02,4.28.79,8.4,2.2,12.22,1.81,4.92,4.67,9.32,8.32,12.95h0s0,0,0,0c4.23,4.22,9.51,7.38,15.42,9.07,3.05.88,6.28,1.35,9.6,1.38h0s.25,0,.25,0h.04c4.06-.01,7.97-.7,11.62-1.96,5.2-1.8,9.86-4.76,13.67-8.57,3.62-3.64,6.48-8.06,8.28-13,1.33-3.63,2.08-7.54,2.16-11.6v-.02s0-.74,0-.74c-.08-13.74-6.63-30.03-13.78-44.31Zm-42.4,64.86c-2.94-2.93-5.25-6.49-6.72-10.46-1.15-3.1-1.77-6.45-1.78-9.97v-.22h0c0-11.52,6.02-27.32,12.91-41.05,3.31-6.64,6.8-12.83,9.87-17.96,2.35-3.94,4.44-7.25,6-9.66,1.58,2.4,3.68,5.71,6.04,9.64,3.08,5.12,6.59,11.3,9.92,17.93,6.96,13.74,13.03,29.57,13.05,41.1,0,.05,0,.1,0,.14h0c0,3.52-.61,6.87-1.75,9.97-1.45,3.98-3.75,7.55-6.68,10.49-3.07,3.08-6.84,5.47-11.04,6.92-2.93,1.02-6.08,1.57-9.38,1.58h-.01c-2.77,0-5.44-.38-7.97-1.11-4.76-1.36-9.03-3.92-12.45-7.33h0Zm20.4-216.3c-21.97,0-39.78,23.63-39.78,52.78s17.82,52.78,39.78,52.78,39.78-23.63,39.78-52.78-17.8-52.78-39.78-52.78Zm202.29,0c-21.97,0-39.78,23.63-39.78,52.78s17.82,52.78,39.78,52.78,39.78-23.63,39.78-52.78-17.81-52.78-39.78-52.78Z"
                            />
                        </svg>
                        <span class="shadow-text-none">
                            {{ message }}
                        </span>
                    </div>
                    <div
                        class="footer-box flex justify-center items-center d-flex justify-content-center align-items-center mt-4"
                    >
                        <template v-if="i18n">
                            <XButton
                                v-if="showRetryButton"
                                @click="$emit('retry')"
                                class="cursor-pointer shadow-text-none"
                                bg-color="var(--button-background-color)"
                                color="var(--button-text-color)"
                            >
                                {{ $t('robot_sorry_modal_button_retry') }}
                            </XButton>
                            <XButton
                                @click="$emit('close')"
                                class="cursor-pointer shadow-text-none"
                                :bg-color="showRetryButton ? '#f7f8fa' : 'var(--button-background-color)'"
                                :color="showRetryButton ? '#000' : 'var(--button-text-color)'"
                            >
                                {{ $t('robot_sorry_modal_button_close') }}
                            </XButton>
                        </template>

                        <template v-else>
                            <button
                                @click.stop="$emit('retry')"
                                type="button"
                                class="p-2 p-6 font-opensans btn btn-info system-button-color system-button-text-color"
                                data-dismiss="modal"
                            >
                                Retry
                            </button>
                            <button
                                @click.stop="$emit('close')"
                                type="button"
                                class="p-2 p-6 font-opensans btn btn-secondary system-button-color system-button-text-color"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XButton from '../../../../src/components/v2/XButton'

export default {
    components: {
        XButton
    },

    props: {
        message: {
            type: String,
            default: ''
        },

        showRetryButton: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        i18n() {
            return this.$t ? true : false
        }
    }
}
</script>

<style lang="scss">
.robot-sorry-alert {
    .modal-content {
        max-width: 500px;
        border-radius: 0.3rem;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.5);

        .modal-body {
            min-height: unset !important;

            .content-box {
                column-gap: 1rem;
                .cry-icon {
                    width: 50%;
                    max-width: 75px;
                    fill: #6c757d;
                }
            }

            .footer-box {
                column-gap: 1rem;
                .x-button {
                    height: 35px;
                    padding: 0.5rem 3rem;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
